/**
 * A native-scrolling row of product cards, with arrows on hover devices.
 * Slide widths are set in CSS; the gap and edge offset are read from
 * `--product-rail-gap` and `--product-rail-offset` so Swiper's snap points
 * account for them.
 */
class ProductRail extends HTMLElement {
  connectedCallback() {
    window.loadSwiper.then(({ Swiper, Navigation }) => {
      if (!this.isConnected) return;

      this.swiper = new Swiper(this, {
        modules: [Navigation],
        cssMode: true,
        slidesPerView: "auto",
        spaceBetween: this._gap,
        slidesOffsetBefore: this._offset,
        slidesOffsetAfter: this._offset,
        // Swiper cancels pointerdown on anything but form controls, which
        // stops a clicked card link taking focus. A modal it opens would then
        // be focused from nothing, which browsers show as :focus-visible.
        // cssMode scrolls natively, so there's no drag for this to protect.
        touchStartPreventDefault: false,
        navigation: {
          nextEl: this.querySelector("[data-rail-next]"),
          prevEl: this.querySelector("[data-rail-previous]"),
        },
        on: {
          beforeResize: (swiper) => {
            swiper.params.spaceBetween = this._gap;
            swiper.params.slidesOffsetBefore = this._offset;
            swiper.params.slidesOffsetAfter = this._offset;
          },
        },
      });
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy();
    this.swiper = null;
  }

  get _gap() {
    return this._cssPixels("--product-rail-gap");
  }

  get _offset() {
    return this._cssPixels("--product-rail-offset");
  }

  _cssPixels(property) {
    return parseFloat(getComputedStyle(this).getPropertyValue(property)) || 0;
  }
}

if (!customElements.get("product-rail")) {
  customElements.define("product-rail", ProductRail);
}
